export async function getRecentNews() {
  const accessToken = process.env.REACT_APP_ACCESS_TOKEN;
  const spaceId = '124h1xezlabw';
  const environment = 'master';
  const contentType = 'recentNews';

  const url = `https://cdn.contentful.com/spaces/${spaceId}/environments/${environment}/entries?access_token=${accessToken}&content_type=${contentType}`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error: ${response.status} ${response.statusText}`);
    }
    const data = await response.json();
    return data; // ✅ Return whole object so you have items + includes
  } catch (error) {
    console.error('Failed to fetch recent news:', error);
    return { items: [], includes: { Asset: [] } };
  }
}
